import { useMutation, useQueryClient } from '@tanstack/react-query'

import api from '@/lib/api'
import { useAccessToken, useCurrentUser } from '@/features/auth/state/auth'
import { Darf } from './useCreateDarfs'

export interface UpdateDarfRequest {
  id: string
  body: {
    anoCompetencia?: string
    mesCompetencia?: string
    value?: number
    status?: boolean
    id_user?: string
    observacao?: string
    id_apuracao_competencia?: string
    id_client?: string
    isPago?: boolean
    isAtivo?: boolean
  }
}

export interface UpdateDarfResponse extends Darf {
  id: string
}
export function useUpdateDarf() {
  const token = useAccessToken()
  const user = useCurrentUser()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, body }: UpdateDarfRequest): Promise<UpdateDarfResponse> => {
      if (!id?.trim()) {
        throw new Error('id é obrigatório')
      }

      if (!user || !token) {
        throw new Error('Usuário não autenticado')
      }

      const response = await api.patch<UpdateDarfResponse>(`/darfs/${id}`, body, {
        headers: { Authorization: `Bearer ${token}` }
      })

      if (!response.data?.id) {
        throw new Error('Erro ao atualizar DARF')
      }

      return response.data
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['darfs'] })
      queryClient.invalidateQueries({ queryKey: ['darf', variables.id] })

      if (variables.body.id_apuracao_competencia) {
        queryClient.invalidateQueries({
          queryKey: ['darfs', 'apuracao', variables.body.id_apuracao_competencia]
        })
      }

      if (data.id_apuracao_competencia) {
        queryClient.invalidateQueries({
          queryKey: ['darfs', 'apuracao', data.id_apuracao_competencia]
        })
      }
    }
  })
}